import React from 'react';
import { Nav } from './components/Nav';
import { Footer } from './components/Footer';
import { Hero } from './sections/Hero';
import { TrustedBy } from './sections/TrustedBy';
import { CustomerQuote } from './sections/CustomerQuote';
import { PainSymptoms } from './sections/PainSymptoms';
import { TodayVsPigeon } from './sections/TodayVsPigeon';
import { Workflows } from './sections/Workflows';
import { AutomatedLoop } from './sections/AutomatedLoop';
import { Spotlights } from './sections/Spotlights';
import { ESignature } from './sections/ESignature';
import { EverythingElse } from './sections/EverythingElse';
import { TrustAndLaunch } from './sections/TrustAndLaunch';
import { DeveloperAPI } from './sections/DeveloperAPI';
import { SecurityCompliance } from './sections/SecurityCompliance';
import { CTA } from './sections/CTA';
export function App() {
  return <div className="min-h-screen w-full bg-zinc-950 text-zinc-200 antialiased" data-id="element-0">
      <Nav data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <TrustedBy data-id="element-4" />
        <Workflows data-id="element-5" />
        <TodayVsPigeon data-id="element-6" />
        <CustomerQuote data-id="element-7" />
        <AutomatedLoop data-id="element-8" />
        <Spotlights data-id="element-9" />
        <ESignature data-id="element-10" />
        <EverythingElse data-id="element-11" />
        <TrustAndLaunch data-id="element-12" />
        <DeveloperAPI data-id="element-13" />
        <SecurityCompliance data-id="element-14" />
        <CTA data-id="element-15" />
      </main>
      <Footer data-id="element-16" />
    </div>;
}